import React, {Component} from 'react';

import styles from '../../../static/css/componentStyleModules/inputComponentStyleModules/inlineRadio.module.scss';

export default class InlineRadio extends Component {

    constructor(props){
        super(props);
        this.state = {

        }
    }

    changeValue = (value) => {
        this.props.onRadioClick(value);
    }

    render() {

        const radioButtonStyle = {
            fontSize:this.props.fontSize,
            width:this.props.width,
            height:this.props.height,
            
        }

        const checkedStyle = {
            color:'#ffffff',
            backgroundColor:this.props.color,
            borderColor:this.props.color,
        }

        Object.assign(checkedStyle, radioButtonStyle);

        return (
            <div className={styles['inlineRadio']}>
              {this.props.buttonList.map((radio,index) => {
                  return (
                      <div className={styles['inlineRadioButton']}
                      style={radio.value === this.props.value ? checkedStyle : radioButtonStyle}
                      key={index}
                      onClick={() => this.changeValue(radio.value)}>
                        {radio.display}
                      </div>
                  )
              })}
            </div>
        )
    }

};

// Propsのデフォルト値
InlineRadio.defaultProps = {
    buttonList:[
        {display:'いちばん',value:'１'},
        {display:'にばん',value:'２'},
        {display:'さんばん',value:'３'}
    ],
    value:'１',
    color:'hsl(6,77%,62%)',
    fontSize:'14px',
    width:'100px',
    height:'32px'
};
